import createLocationModel from './lib/create_location_model';

export default createLocationModel({
  modelName: 'UserResetPassword',
  properties: {},
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/location/user_reset_password.js